import axiosInstance from "./api";

export const listUsers = async ({
  page = 1,
  limit = 10,
  sort,
  q,
  field,
  position,
} = {}) => {
  return axiosInstance.get("users/getElms", {
    params: { page, limit, sort, q, field, position },
  });
};

export const getElmsForFeature = async ({
  page = 1,
  limit = 10,
  sort,
  q,
  type,
  position,
  positionOrderGt,
  positionOrderLt,
  includeWardChief,
} = {}) => {
  return axiosInstance.get("users/getElmsForFeature", {
    params: {
      page,
      limit,
      sort,
      q,
      type,
      position,
      positionOrderGt,
      positionOrderLt,
      includeWardChief,
    },
  });
};

export const getElmsByGroups = async () => {
  return axiosInstance.get("users/getElmsByGroups", {
    _returnRawData: true,
  });
};

export const createUser = async ({ data }) => {
  return axiosInstance.post("users/createElm", data);
};

export const updateUser = async ({ id, data }) => {
  return axiosInstance.put(`users/updateElm/${id}`, data);
};

export const deleteUser = async ({ id }) => {
  return axiosInstance.delete(`users/deleteElm/${id}`);
};

export const getUser = async ({ id }) => {
  return axiosInstance.get(`users/getElm/${id}`);
};
export const uploadAvatar = async (formData) => {
  return axiosInstance.post("users/uploadAvatar", formData);
};
export const updateStatus = async ({ id }) => {
  return axiosInstance.put(`users/updateStatus/${id}`);
};

export const checkDuplicateCode = async ({ code }) => {
  return axiosInstance.get("users/checkDuplicateCode", {
    params: { code },
  });
};

export const getSuperiors = async (params = {}) => {
  return axiosInstance.get("users/getSuperiors", {
    params,
  });
};

export const changePassword = async (
  id,
  oldPassword,
  newPassword,
  confirmPassword,
) => {
  return axiosInstance.put(`users/changePassword/${id}`, {
    oldPassword,
    newPassword,
    confirmPassword,
  });
};

export const updateInfor = async ({ id, ...data }) => {
  return axiosInstance.put(`users/updateInfor/${id}`, data);
};

export const importExcel = async (formData) => {
  return axiosInstance.post("users/importExcel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 30000,
  });
};

export const checkExcel = async (formData) => {
  return axiosInstance.post("users/checkExcel", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 30000,
  });
};

export const exportUsers = async (params) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
  ).toString();
  const url = `${baseUrl}/users/exportExcel${query ? `?${query}` : ""}`;

  const token = axiosInstance._getAccessToken?.();
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const response = await fetch(url, { headers, credentials: "include" });
  if (!response.ok) {
    throw new Error(
      `Export thất bại: ${response.status} ${response.statusText}`,
    );
  }
  return response.blob();
};
